export default __webpack_public_path__ + "static/media/404.1a51c1e1.svg";